
<form class="form-horizontal" #form="ngForm" (ngSubmit)="saveAssistanceBill()">
  <app-tabs [select_tab]="select_tab">
    <!--bill tab-->
    <app-tab [tabTitle]="'Bill'" class="tab-cls">
      <div class="form-group">
        <label class="control-label col-sm-3">{{ 'Price agreed' | translate }}</label>
        <div class="col-sm-9 input-group">
          <span class="form-group input-group-btn input-group-addon">
          {{country.currency_symbol}}
          </span>
          <input [focus]="inputFocused" type="number" class="form-control" [(ngModel)]="bill.price_agreed" name="price_agreed" required>
        </div>
      </div>
      <div class="form-group" *ngIf="bill.status == BILL_STATUSES.CHARGED">
        <label class="control-label col-sm-3">{{ 'Price billed' | translate }}</label>
        <div class="col-sm-9 input-group">
          <span class="form-group input-group-btn input-group-addon">
          {{country.currency_symbol}}
          </span>
          <input type="number" class="form-control" [(ngModel)]="bill.price_billed" name="price_billed" required>
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-3">{{ 'Note' | translate }}</label>
        <div class="col-sm-9">
            <textarea rows="5" cols="10" class="form-control" pattern=".{1,100}"
                      placeholder="{{ 'Enter note' | translate }}"
                      [(ngModel)]="bill.note" name="note" #note="ngModel">
            </textarea>
        </div>
      </div>

      <div class="form-group">
        <div *ngIf="price && price.assistance_price_extras.length > 0  && bill.bill_price_extras.length > 0" class="col-sm-offset-3 col-sm-9 div-btn-right">
          <button class="btn btn-primary btn-sm btn-right" type="button" (click)="setActive('Extras')">{{ 'Next' | translate }}</button>
          <button class="btn btn-default btn-sm btn-right" type="button" (click)="onCancel()">{{ 'Cancel' | translate }}</button>
        </div>
      </div>
      <div *ngIf="price && price.assistance_price_extras.length == 0  || bill.bill_price_extras.length == 0" class="form-group">
        <div class="col-sm-offset-3 col-sm-9 div-btn-right">
          <button type="button" class="btn btn-default btn-sm" (click)="onCancel()">{{ 'Cancel' | translate }}</button>
          <button type="submit" class="btn btn-primary btn-sm" [disabled]="form.form.invalid || isDisabled">{{ 'Update' | translate }}</button>
        </div>
      </div>
    </app-tab>

    <!--extra price tab-->
    <app-tab *ngIf="price && price.assistance_price_extras.length > 0 && bill.bill_price_extras.length > 0" [tabTitle]="'Extras'" class="tab-cls">
      <div class="e-price-panel" *ngFor="let bpe of bill.bill_price_extras; let i=index">
        <ng-container *ngIf="price.assistance_price_extras[i].price_type == type_fixed">
          <div class="form-group">
            <label class="control-label col-sm-3">{{ 'Value' | translate }}:</label>
            <div class="col-sm-9">
              <label class="radio-inline">
                <input type="radio" [(ngModel)]="bpe.value" name="'fixed_status'+{{i}}" [value]=1 (ngModelChange)="onChangeExtraValue($event, i)">
                {{ 'Yes' | translate }}
              </label>
              <label class="radio-inline">
                <input type="radio" [(ngModel)]="bpe.value" name="'fixed_status'+{{i}}" [value]=0 (ngModelChange)="onChangeExtraValue($event, i)">
                {{ 'No' | translate }}
              </label>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="price.assistance_price_extras[i].price_type == type_unit">
          <div class="form-group">
            <label class="control-label col-sm-3">{{ 'Value' | translate }}</label>
            <div class="col-sm-9 input-group">
              <input type="number" name="'e_value' + {{i}}" class="form-control" [(ngModel)]="bpe.value" (ngModelChange)="onChangeExtraValue($event, i)" pattern="[^\-]+" step="0.01" min="0">
            </div>
          </div>
        </ng-container>
        <div class="form-group">
          <label class="control-label col-sm-3">{{ 'Extra Price' | translate }}</label>
          <div class="col-sm-9 input-group">
            <input type="number" name="'e_price' + {{i}}" class="form-control" [ngModel]="bpe.price" disabled>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="col-sm-offset-3 col-sm-9 div-btn-right">
          <button type="button" class="btn btn-default btn-sm" (click)="onCancel()">{{ 'Cancel' | translate }}</button>
          <button type="submit" class="btn btn-primary btn-sm" [disabled]="form.form.invalid || isDisabled">{{ 'Update' | translate }}</button>
        </div>
      </div>
    </app-tab>
  </app-tabs>
</form>


